import React from 'react';
import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTimes } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';

const FaqCard = ({ faq, excluir }) => {

    const history = useHistory();

    return (
        <div className={styles.wrapper}>
            <div className={styles.bodyCard}>
                <div className={styles.title}>
                    Pergunta:
                </div>
                <div className={styles.info}>
                    {faq.titulo}
                </div>
                <div className={styles.title}>
                    Ordem
                </div>
                <div className={styles.info}>
                    {faq.ordem}
                </div>
            </div>

            <div className={styles.actionWrapper}>

                { !faq.ativo && (<div className={styles.encerrado}>INATIVO</div>) }
                { faq.ativo && (<div className={styles.andamento}>ATIVO</div>) }
                
                <button className={styles.editar} onClick={() => {excluir(faq.faqId)}}>
                    Inativar
                    <FontAwesomeIcon icon={faTimes} className={styles.icon}/>
                </button>

                <button className={styles.editar} onClick={() => {history.push(`/faq/detalhe?FaqId=${faq.faqId}`)}}>
                    Editar
                    <FontAwesomeIcon icon={faEdit} className={styles.icon}/>
                </button>
            </div>

        </div>
    )
}

export default FaqCard;